export default "__VITE_ASSET__DaMnq8Cl__"